import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  title: 'The Ready-to-Grade Rubric Vault',
  price: '$19',
  image: 'https://cdn.magicpatterns.com/uploads/wXJfhdMWEhy36beGF6N9Pz/Art_1.webp'
}, {
  title: 'Art Teacher’s Year-at-a-Glance Planner (2026–27)',
  price: '$27',
  image: 'https://cdn.magicpatterns.com/uploads/giQhBp375MvxHnjdebrQNz/Art_2.webp'
}, {
  title: 'The No-Budget Art Materials Playbook',
  price: '$36',
  image: 'https://cdn.magicpatterns.com/uploads/jrSiZVUK5eXpnxytMeDjBT/Art_3.webp'
}, {
  title: '50 Artists Every Student Should Know',
  price: '$47',
  image: 'https://cdn.magicpatterns.com/uploads/n6ZKyRoZyatQ8mM19VUdaB/Art_4.webp'
}, {
  title: 'Student Portfolio & Critique Templates',
  price: '$19',
  image: 'https://cdn.magicpatterns.com/uploads/dzsCFcFJMuuuN4RYFgisms/Art_5.webp'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-219">
      <Reveal className="mx-auto max-w-3xl" data-id="element-220">
        <div className="mb-12 text-center" data-id="element-221">
          <h2 className="text-3xl font-black md:text-4xl" data-id="element-222">
            🎁 5 Exclusive Bonuses
          </h2>
          <p className="mt-4 text-brand-gray" data-id="element-223">
            Valued at{' '}
            <span className="font-bold text-brand-orange line-through" data-id="element-224">
              $148 USD
            </span>{' '}
            — Included <strong className="text-brand-red" data-id="element-225">FREE</strong>
          </p>
        </div>

        <div className="space-y-3" data-id="element-226">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-black/[0.04] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-227">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-red font-serif font-bold text-white" data-id="element-228">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-16 w-12 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-20 sm:w-14" data-id="element-229" />
              <div className="min-w-0 flex-1" data-id="element-230">
                <h3 className="font-bold leading-snug" data-id="element-231">{bonus.title}</h3>
                <p className="mt-1 text-xs" data-id="element-232">
                  <span className="text-brand-orange line-through" data-id="element-233">
                    was {bonus.price}
                  </span>
                  <span className="ml-2 font-extrabold text-brand-red" data-id="element-234">
                    FREE
                  </span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}